import { useFormatter } from '@api/useFormatter'
import { BBDTag } from '@gravitate-js/excalibrr'

type SupplyPriceTagProps = {
  price: string
  deltaToLow?: number
  className?: string
}

export function SupplyPriceTag({ price, deltaToLow }: SupplyPriceTagProps) {
  const { formatCurrency } = useFormatter()
  const formattedPrice = formatCurrency(Number.parseFloat(price), true, 4)
  if (deltaToLow == null) return <BBDTag className='mr-0' warning>{`${formattedPrice} (Old)`}</BBDTag>
  if (deltaToLow > 0) return <BBDTag className='mr-0' error>{`${formattedPrice} (+${deltaToLow.toFixed(4)})`}</BBDTag>
  return <BBDTag className='mr-0' success>{`${formattedPrice} (Low)`}</BBDTag>
}
